export const removeNullValues = <T extends Object>(object: T): T => Object
  .entries(object).reduce((nextObject, [key, value]) => (
    value === null
      ? nextObject
      : { ...nextObject, [key]: value }
  ), {} as T);

export default removeNullValues;
